import { WIDGET_VIEW_TIME_SPAN } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TimeSpanViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_TIME_SPAN,
  component: () => import("./time-span-view-widget.component").then((m) => m.TimeSpanViewWidgetComponent)
};
